import { createSvgIcon } from '@mui/material';

export const POS = createSvgIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='76'
    height='76'
    viewBox='0 0 76 76'
    fill='none'
  >
    <path
      d='M11.0771 19.9998C11.0771 18.3004 12.4547 16.9229 14.1541 16.9229H29.8464V62.4613H14.1541C12.4547 62.4613 11.0771 61.0837 11.0771 59.3844V19.9998Z'
      fill='url(#paint0_linear_515_489)'
    />
    <rect
      x='16.3086'
      y='23.2544'
      width='8.48806'
      height='10.4047'
      rx='1.09523'
      fill='#C86904'
    />
    <path
      d='M18.4577 45.0205C18.4577 42.6759 18.4611 40.3332 18.4577 37.9886C18.4577 37.2204 18.0744 36.7646 17.446 36.7508C16.7934 36.737 16.3911 37.2083 16.3894 38.0111C16.3859 42.6777 16.3859 47.3443 16.3894 52.0091C16.3894 52.9051 16.9729 53.4628 17.6894 53.2453C18.266 53.0692 18.4663 52.6358 18.4628 52.0523C18.4525 49.7078 18.4577 47.365 18.4594 45.0205H18.4577Z'
      fill='#C86904'
    />
    <rect
      x='16.3086'
      y='22.6387'
      width='8.48806'
      height='10.4047'
      rx='1.09523'
      fill='#ffffff'
    />
    <path
      d='M18.4577 44.4052C18.4577 42.0607 18.4611 39.7179 18.4577 37.3734C18.4577 36.6051 18.0744 36.1494 17.446 36.1355C16.7934 36.1217 16.3911 36.5931 16.3894 37.3959C16.3859 42.0624 16.3859 46.729 16.3894 51.3939C16.3894 52.2899 16.9729 52.8476 17.6894 52.63C18.266 52.4539 18.4663 52.0206 18.4628 51.437C18.4525 49.0925 18.4577 46.7497 18.4594 44.4052H18.4577Z'
      fill='#ffffff'
    />
    <path
      d='M57.9411 15.0914C57.9381 16.1217 57.9351 17.152 57.9316 18.1826L57.9299 18.1809L41.3818 18.1654C41.3818 18.166 41.3819 18.1666 41.3819 18.1672L37.2522 18.1827C37.2496 17.152 37.2466 16.1213 37.2436 15.0906C37.2405 14.0599 37.2375 13.0293 37.2349 11.9986C37.2349 11.3177 37.2357 10.6367 37.2364 9.95567C37.2382 8.32085 37.24 6.68567 37.2315 5.05135C37.2297 4.49716 37.3143 4.01375 37.8944 3.79104C38.4642 3.57178 38.8716 3.85319 39.2583 4.2451C39.7432 4.73601 40.2408 5.21592 40.738 5.69549C40.9502 5.90013 41.1623 6.1047 41.3733 6.31005C41.3733 6.30941 41.3733 6.30878 41.3733 6.30815L41.374 6.30742C42.1127 5.58946 42.8514 4.8715 43.5935 4.15527C44.2323 3.53893 44.7416 3.5372 45.3804 4.1639C46.0105 4.78197 46.6407 5.40004 47.2501 6.0371C47.5039 6.30297 47.6765 6.30124 47.9303 6.0371C48.5398 5.40005 49.1699 4.782 49.8 4.16395C50.4388 3.53725 50.9516 3.53547 51.5869 4.15699C51.6427 4.21161 51.6984 4.26622 51.7542 4.32083C52.3134 4.86865 52.8732 5.41698 53.4101 5.9853C53.6915 6.28398 53.8848 6.32541 54.1853 6.00084C54.516 5.64398 54.8631 5.30225 55.2103 4.96045C55.4611 4.71357 55.7119 4.46666 55.9566 4.21397C56.3468 3.81171 56.7663 3.56655 57.3326 3.80825C57.8798 4.04132 57.9524 4.50746 57.9506 5.03576C57.9449 6.58374 57.9468 8.13095 57.9487 9.67843C57.9497 10.4523 57.9506 11.2262 57.9506 12.0002C57.9472 13.0309 57.9442 14.0612 57.9411 15.0914Z'
      fill='#EFEFEF'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M37.2313 11.6924V18.1539H36.1544C35.5596 18.1539 35.0774 18.6361 35.0774 19.2308C35.0774 19.8256 35.5596 20.3078 36.1544 20.3078H58.9236C59.5184 20.3078 60.0005 19.8256 60.0005 19.2308C60.0005 18.6361 59.5184 18.1539 58.9236 18.1539H57.8467V11.6924H61.8467C63.546 11.6924 64.9236 13.07 64.9236 14.7693V62.4616C64.9236 64.1609 63.546 65.5385 61.8467 65.5385H32.9236C31.2243 65.5385 29.8467 64.1609 29.8467 62.4616V14.7693C29.8467 13.07 31.2243 11.6924 32.9236 11.6924H37.2313Z'
      fill='url(#paint1_linear_515_489)'
    />
    <rect
      x='35.0771'
      y='18.1538'
      width='24.9231'
      height='2.15385'
      rx='1.07692'
      fill='#4E5460'
    />
    <rect
      x='35.0771'
      y='23.0771'
      width='24.9231'
      height='12.6154'
      rx='0.923077'
      fill='#2962FF'
    />
    <rect
      x='35.1113'
      y='43.7808'
      width='6.2976'
      height='6.2976'
      rx='1.09523'
      fill='#2962FF'
    />
    <rect
      x='44.4209'
      y='53.0903'
      width='6.2976'
      height='6.2976'
      rx='1.09523'
      fill='#2962FF'
    />
    <rect
      x='44.4209'
      y='43.7808'
      width='6.2976'
      height='6.2976'
      rx='1.09523'
      fill='#2962FF'
    />
    <rect
      x='53.7305'
      y='53.0903'
      width='6.2976'
      height='6.2976'
      rx='1.09523'
      fill='#2962FF'
    />
    <rect
      x='53.7305'
      y='43.7808'
      width='6.2976'
      height='6.2976'
      rx='1.09523'
      fill='#2962FF'
    />
    <rect
      x='35.1113'
      y='38.5786'
      width='6.2976'
      height='2.19047'
      rx='1.09523'
      fill='#2962FF'
    />
    <rect
      x='44.4209'
      y='38.5786'
      width='6.2976'
      height='2.19047'
      rx='1.09523'
      fill='#2962FF'
    />
    <rect
      x='53.7305'
      y='38.5786'
      width='6.2976'
      height='2.19047'
      rx='1.09523'
      fill='#2962FF'
    />
    <rect
      x='35.0771'
      y='22.4614'
      width='24.9231'
      height='12.6154'
      rx='0.923077'
      fill='#ffffff'
    />
    <rect
      x='35.1113'
      y='43.165'
      width='6.2976'
      height='6.2976'
      rx='1.09523'
      fill='#ffffff'
    />
    <rect
      x='44.4209'
      y='52.4746'
      width='6.2976'
      height='6.2976'
      rx='1.09523'
      fill='#ffffff'
    />
    <rect
      x='44.4209'
      y='43.165'
      width='6.2976'
      height='6.2976'
      rx='1.09523'
      fill='#ffffff'
    />
    <rect
      x='53.7305'
      y='52.4746'
      width='6.2976'
      height='6.2976'
      rx='1.09523'
      fill='#ffffff'
    />
    <rect
      x='53.7305'
      y='43.165'
      width='6.2976'
      height='6.2976'
      rx='1.09523'
      fill='#ffffff'
    />
    <rect
      x='35.1113'
      y='37.9629'
      width='6.2976'
      height='2.19047'
      rx='1.09523'
      fill='#77ED8B'
    />
    <rect
      x='44.4209'
      y='37.9629'
      width='6.2976'
      height='2.19047'
      rx='1.09523'
      fill='#FFD666'
    />
    <rect
      x='53.7305'
      y='37.9629'
      width='6.2976'
      height='2.19047'
      rx='1.09523'
      fill='#FFAC82'
    />
    <path
      d='M29.8467 61.5386H64.9236V62.4617C64.9236 64.161 63.546 65.5386 61.8467 65.5386H32.9236C31.2243 65.5386 29.8467 64.161 29.8467 62.4617V61.5386Z'
      fill='#2962FF'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.4044 55.8768C10.677 51.3327 14.8492 48 19.7997 48C24.6147 48 28.6933 51.1527 30.084 55.5064H31.7968C36.4973 55.5064 40.3078 59.3169 40.3078 64.0174C40.3078 68.7179 36.4973 72.5284 31.7968 72.5284H11.8958C7.19529 72.5284 3.38477 68.7179 3.38477 64.0174C3.38477 60.1837 5.91945 56.9421 9.4044 55.8768Z'
      fill='url(#paint2_linear_515_489)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.96336 53.5292C9.03624 48.481 13.999 44.9229 19.7995 44.9229C25.1712 44.9229 29.824 47.9747 32.1288 52.4339C38.375 52.6097 43.3845 57.7284 43.3845 64.0172C43.3845 70.417 38.1964 75.6051 31.7966 75.6051H11.8956C5.49573 75.6051 0.307617 70.417 0.307617 64.0172C0.307617 59.3778 3.0321 55.3812 6.96336 53.5292ZM9.40417 55.8766C10.6768 51.3324 14.8489 47.9998 19.7995 47.9998C24.6145 47.9998 28.6931 51.1524 30.0838 55.5061H31.7966C36.4971 55.5061 40.3076 59.3167 40.3076 64.0172C40.3076 68.7177 36.4971 72.5282 31.7966 72.5282H11.8956C7.19506 72.5282 3.38454 68.7177 3.38454 64.0172C3.38454 60.1835 5.91922 56.9418 9.40417 55.8766Z'
      fill='#ffffff'
    />
    <path
      d='M10.7405 67.5386V60.0001H14.0036C14.6785 60.0001 15.26 60.1114 15.7482 60.334C16.2364 60.5493 16.6133 60.8617 16.879 61.2709C17.1446 61.6801 17.2774 62.1683 17.2774 62.7355C17.2774 63.2955 17.1446 63.7801 16.879 64.1893C16.6133 64.5986 16.2364 64.9145 15.7482 65.137C15.26 65.3524 14.6785 65.4601 14.0036 65.4601H11.7098L12.4851 64.674V67.5386H10.7405ZM12.4851 64.8678L11.7098 64.0386H13.9067C14.4451 64.0386 14.8472 63.9237 15.1128 63.694C15.3785 63.4642 15.5113 63.1447 15.5113 62.7355C15.5113 62.3191 15.3785 61.996 15.1128 61.7663C14.8472 61.5365 14.4451 61.4217 13.9067 61.4217H11.7098L12.4851 60.5924V64.8678ZM22.2897 67.6678C21.6938 67.6678 21.141 67.5709 20.6312 67.377C20.1287 67.1832 19.6907 66.9104 19.3174 66.5586C18.9512 66.2068 18.664 65.794 18.4558 65.3201C18.2548 64.8463 18.1543 64.3293 18.1543 63.7693C18.1543 63.2093 18.2548 62.6924 18.4558 62.2186C18.664 61.7447 18.9548 61.3319 19.3281 60.9801C19.7015 60.6283 20.1394 60.3555 20.642 60.1617C21.1446 59.9678 21.6902 59.8709 22.2789 59.8709C22.8748 59.8709 23.4205 59.9678 23.9158 60.1617C24.4184 60.3555 24.8528 60.6283 25.2189 60.9801C25.5922 61.3319 25.883 61.7447 26.0912 62.2186C26.2994 62.6852 26.4035 63.2022 26.4035 63.7693C26.4035 64.3293 26.2994 64.8499 26.0912 65.3309C25.883 65.8047 25.5922 66.2175 25.2189 66.5693C24.8528 66.914 24.4184 67.1832 23.9158 67.377C23.4205 67.5709 22.8784 67.6678 22.2897 67.6678ZM22.2789 66.1817C22.6164 66.1817 22.9251 66.1242 23.2051 66.0093C23.4922 65.8945 23.7435 65.7293 23.9589 65.514C24.1743 65.2986 24.3394 65.0437 24.4543 64.7493C24.5764 64.455 24.6374 64.1283 24.6374 63.7693C24.6374 63.4104 24.5764 63.0837 24.4543 62.7893C24.3394 62.495 24.1743 62.2401 23.9589 62.0247C23.7507 61.8093 23.503 61.6442 23.2158 61.5293C22.9287 61.4145 22.6164 61.357 22.2789 61.357C21.9415 61.357 21.6292 61.4145 21.342 61.5293C21.062 61.6442 20.8143 61.8093 20.5989 62.0247C20.3835 62.2401 20.2148 62.495 20.0928 62.7893C19.9779 63.0837 19.9205 63.4104 19.9205 63.7693C19.9205 64.1211 19.9779 64.4478 20.0928 64.7493C20.2148 65.0437 20.3799 65.2986 20.5881 65.514C20.8035 65.7293 21.0548 65.8945 21.342 66.0093C21.6292 66.1242 21.9415 66.1817 22.2789 66.1817ZM30.1916 67.6678C29.5885 67.6678 29.0106 67.5888 28.4578 67.4309C27.9049 67.2658 27.4598 67.054 27.1224 66.7955L27.7147 65.4817C28.0378 65.7114 28.4183 65.9017 28.8562 66.0524C29.3013 66.196 29.7501 66.2678 30.2024 66.2678C30.547 66.2678 30.8234 66.2355 31.0316 66.1709C31.247 66.0991 31.4049 66.0022 31.5055 65.8801C31.606 65.7581 31.6562 65.6181 31.6562 65.4601C31.6562 65.2591 31.5772 65.1011 31.4193 64.9863C31.2613 64.8642 31.0531 64.7673 30.7947 64.6955C30.5362 64.6165 30.249 64.5447 29.9331 64.4801C29.6244 64.4083 29.3121 64.3222 28.9962 64.2217C28.6875 64.1211 28.4039 63.9919 28.1455 63.834C27.887 63.676 27.6752 63.4678 27.5101 63.2093C27.3521 62.9509 27.2731 62.6206 27.2731 62.2186C27.2731 61.7878 27.388 61.3965 27.6178 61.0447C27.8547 60.6858 28.2065 60.4022 28.6731 60.194C29.147 59.9786 29.7393 59.8709 30.4501 59.8709C30.9239 59.8709 31.3906 59.9283 31.8501 60.0432C32.3096 60.1509 32.7152 60.316 33.067 60.5386L32.5285 61.8632C32.1767 61.6622 31.8249 61.515 31.4731 61.4217C31.1213 61.3211 30.7767 61.2709 30.4393 61.2709C30.1019 61.2709 29.8255 61.3104 29.6101 61.3893C29.3947 61.4683 29.2403 61.5724 29.147 61.7017C29.0537 61.8237 29.007 61.9673 29.007 62.1324C29.007 62.3263 29.086 62.4842 29.2439 62.6063C29.4019 62.7211 29.6101 62.8145 29.8685 62.8863C30.127 62.9581 30.4106 63.0299 30.7193 63.1017C31.0352 63.1734 31.3475 63.256 31.6562 63.3493C31.9721 63.4427 32.2593 63.5683 32.5178 63.7263C32.7762 63.8842 32.9844 64.0924 33.1424 64.3509C33.3075 64.6093 33.3901 64.936 33.3901 65.3309C33.3901 65.7545 33.2716 66.1422 33.0347 66.494C32.7978 66.8458 32.4424 67.1293 31.9685 67.3447C31.5019 67.5601 30.9096 67.6678 30.1916 67.6678Z'
      fill='#252C7E'
    />
    <path
      d='M10.7405 66.9233V59.3849H14.0036C14.6785 59.3849 15.26 59.4962 15.7482 59.7187C16.2364 59.9341 16.6133 60.2464 16.879 60.6556C17.1446 61.0649 17.2774 61.5531 17.2774 62.1203C17.2774 62.6803 17.1446 63.1649 16.879 63.5741C16.6133 63.9833 16.2364 64.2992 15.7482 64.5218C15.26 64.7372 14.6785 64.8449 14.0036 64.8449H11.7098L12.4851 64.0587V66.9233H10.7405ZM12.4851 64.2526L11.7098 63.4233H13.9067C14.4451 63.4233 14.8472 63.3085 15.1128 63.0787C15.3785 62.849 15.5113 62.5295 15.5113 62.1203C15.5113 61.7039 15.3785 61.3808 15.1128 61.151C14.8472 60.9213 14.4451 60.8064 13.9067 60.8064H11.7098L12.4851 59.9772V64.2526ZM22.2897 67.0526C21.6938 67.0526 21.141 66.9556 20.6312 66.7618C20.1287 66.568 19.6907 66.2951 19.3174 65.9433C18.9512 65.5915 18.664 65.1787 18.4558 64.7049C18.2548 64.231 18.1543 63.7141 18.1543 63.1541C18.1543 62.5941 18.2548 62.0772 18.4558 61.6033C18.664 61.1295 18.9548 60.7167 19.3281 60.3649C19.7015 60.0131 20.1394 59.7403 20.642 59.5464C21.1446 59.3526 21.6902 59.2556 22.2789 59.2556C22.8748 59.2556 23.4205 59.3526 23.9158 59.5464C24.4184 59.7403 24.8528 60.0131 25.2189 60.3649C25.5922 60.7167 25.883 61.1295 26.0912 61.6033C26.2994 62.07 26.4035 62.5869 26.4035 63.1541C26.4035 63.7141 26.2994 64.2346 26.0912 64.7156C25.883 65.1895 25.5922 65.6023 25.2189 65.9541C24.8528 66.2987 24.4184 66.568 23.9158 66.7618C23.4205 66.9556 22.8784 67.0526 22.2897 67.0526ZM22.2789 65.5664C22.6164 65.5664 22.9251 65.509 23.2051 65.3941C23.4922 65.2792 23.7435 65.1141 23.9589 64.8987C24.1743 64.6833 24.3394 64.4285 24.4543 64.1341C24.5764 63.8398 24.6374 63.5131 24.6374 63.1541C24.6374 62.7951 24.5764 62.4685 24.4543 62.1741C24.3394 61.8798 24.1743 61.6249 23.9589 61.4095C23.7507 61.1941 23.503 61.029 23.2158 60.9141C22.9287 60.7992 22.6164 60.7418 22.2789 60.7418C21.9415 60.7418 21.6292 60.7992 21.342 60.9141C21.062 61.029 20.8143 61.1941 20.5989 61.4095C20.3835 61.6249 20.2148 61.8798 20.0928 62.1741C19.9779 62.4685 19.9205 62.7951 19.9205 63.1541C19.9205 63.5059 19.9779 63.8326 20.0928 64.1341C20.2148 64.4285 20.3799 64.6833 20.5881 64.8987C20.8035 65.1141 21.0548 65.2792 21.342 65.3941C21.6292 65.509 21.9415 65.5664 22.2789 65.5664ZM30.1916 67.0526C29.5885 67.0526 29.0106 66.9736 28.4578 66.8156C27.9049 66.6505 27.4598 66.4387 27.1224 66.1803L27.7147 64.8664C28.0378 65.0962 28.4183 65.2864 28.8562 65.4372C29.3013 65.5808 29.7501 65.6526 30.2024 65.6526C30.547 65.6526 30.8234 65.6203 31.0316 65.5556C31.247 65.4839 31.4049 65.3869 31.5055 65.2649C31.606 65.1428 31.6562 65.0028 31.6562 64.8449C31.6562 64.6439 31.5772 64.4859 31.4193 64.371C31.2613 64.249 31.0531 64.1521 30.7947 64.0803C30.5362 64.0013 30.249 63.9295 29.9331 63.8649C29.6244 63.7931 29.3121 63.7069 28.9962 63.6064C28.6875 63.5059 28.4039 63.3767 28.1455 63.2187C27.887 63.0608 27.6752 62.8526 27.5101 62.5941C27.3521 62.3356 27.2731 62.0054 27.2731 61.6033C27.2731 61.1726 27.388 60.7813 27.6178 60.4295C27.8547 60.0705 28.2065 59.7869 28.6731 59.5787C29.147 59.3633 29.7393 59.2556 30.4501 59.2556C30.9239 59.2556 31.3906 59.3131 31.8501 59.428C32.3096 59.5356 32.7152 59.7008 33.067 59.9233L32.5285 61.248C32.1767 61.0469 31.8249 60.8998 31.4731 60.8064C31.1213 60.7059 30.7767 60.6556 30.4393 60.6556C30.1019 60.6556 29.8255 60.6951 29.6101 60.7741C29.3947 60.8531 29.2403 60.9572 29.147 61.0864C29.0537 61.2085 29.007 61.3521 29.007 61.5172C29.007 61.711 29.086 61.869 29.2439 61.991C29.4019 62.1059 29.6101 62.1992 29.8685 62.271C30.127 62.3428 30.4106 62.4146 30.7193 62.4864C31.0352 62.5582 31.3475 62.6408 31.6562 62.7341C31.9721 62.8274 32.2593 62.9531 32.5178 63.111C32.7762 63.269 32.9844 63.4772 33.1424 63.7356C33.3075 63.9941 33.3901 64.3208 33.3901 64.7156C33.3901 65.1392 33.2716 65.5269 33.0347 65.8787C32.7978 66.2305 32.4424 66.5141 31.9685 66.7295C31.5019 66.9449 30.9096 67.0526 30.1916 67.0526Z'
      fill='#ffffff'
    />
    <defs>
      <linearGradient
        id='paint0_linear_515_489'
        x1='20.4618'
        y1='16.9229'
        x2='20.4618'
        y2='62.4613'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FCBA73' />
        <stop offset='1' stopColor='#C86904' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_515_489'
        x1='29.8467'
        y1='11.6924'
        x2='64.9236'
        y2='65.5385'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#8CB9FE' />
        <stop offset='1' stopColor='#2962FF' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_515_489'
        x1='8.9463'
        y1='57.318'
        x2='22.6084'
        y2='70.98'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#414CC8' />
        <stop offset='1' stopColor='#2B3493' />
      </linearGradient>
    </defs>
  </svg>,
  'POS',
);
